import React, { useEffect, useRef, useState } from 'react';
import { Form, Input, Switch, Button, Row, Col, Select, Space } from 'antd';
import { ProductCountDto } from '@gtpl/shared-models/raw-material-procurement';
import { RmCountPriceListService } from '@gtpl/shared-services/raw-material-procurement';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { ProductService } from 'libs/shared-services/masters/src/lib/products-service';
import { ProductDto } from '@gtpl/shared-models/masters';
import {  SkuService } from '@gtpl/shared-services/masters';
interface ProductCountFormProps {
  record: ProductCountDto | null;
  onSuccess: () => void;
  onCancel: () => void;
}

export function ProductCountForm(props: ProductCountFormProps) {
  const [form] = Form.useForm();
  const service = new RmCountPriceListService();
  const productService = new ProductService();
  const [products, setProducts] = useState<any[]>([]);
  const createdUser = localStorage.getItem('createdUser') || 'Admin';
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const skuService = new SkuService();
  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
  try {
    const res = await skuService.getAllSku();

    if (res.status) {
      setProducts(res.data || []);
    }
  } catch (err) {
    console.error('Failed to fetch products', err);
  }
};

   

  useEffect(() => {
    if (props.record) {
      form.setFieldsValue({
        productId: props.record.productId,
        productCount: props.record.productCount,
      });
    } else {
      form.resetFields();
    }
  }, [props.record, form]);

  const onFinish = async (values: any) => {
    try {
      const selectedProduct = products.find(p => p.productId === values.productId);
      const payload = {
        ...values,
        productName: selectedProduct ? selectedProduct.productName : '',
        createdUser,
        updatedUser: createdUser,
        productCountId: props.record ? props.record.productCountId : 0,
      };

      const res = props.record
        ? await service.updateProductCount(payload)
        : await service.createProductCount(payload);

      if (res.status) {
        AlertMessages.getSuccessMessage(res.internalMessage || 'Operation successful');
        props.onSuccess();
      } else {
        AlertMessages.getErrorMessage(res.internalMessage || 'Operation failed');
      }
    } catch (err) {
      console.error(err);
      AlertMessages.getErrorMessage('Internal server error');
    }
  };


  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      {/* <Form.Item
        name="productId"
        label="Product"
      >
        <Select
  showSearch
  placeholder="Select Product"
  optionFilterProp="children"
>
  {products.map((e) => (
    <Select.Option
      key={e.skuCodeId}
      value={e.skuCodeId}
    >
      {e.shortCode}
    </Select.Option>
  ))}
</Select>
      </Form.Item> */}
      <Form.Item
        name="productCount"
        label="Count (eg: 23, 25.8, 23/80)"
        rules={[{ required: true, message: 'Please enter product count' }]}
      >
        <Input placeholder="Enter count" />
      </Form.Item>
      
      <Row justify="end">
        <Col>
           <Button onClick={props.onCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            {props.record ? 'Update' : 'Submit'}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default ProductCountForm;